import { Navigate } from 'react-router-dom';

/** 舊 Google 示範路由：導向整合後的登入頁 */
export default function GoogleLogin() {
  return <Navigate to="/login" replace />;
}
